import { combineReducers } from 'redux';

import {
  RELOAD_REQUESTED
} from '../constants/postedPostsConstants';

const csrfToken = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const team = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const currentUser = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const dataTableDataSource = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const reloadKey = (state = 0, action) => {
  switch (action.type) {
    case RELOAD_REQUESTED:
      return state + 1;
    default:
      return state;
  }
};

const authorizedPages = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const hasPosts = (state = false, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const postedPostsReducer = combineReducers({
  csrfToken,
  team,
  currentUser,
  dataTableDataSource,
  reloadKey,
  authorizedPages,
  hasPosts
});

export default postedPostsReducer;
